import { useState } from 'react';

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import Button from '@/components/Button';
import Logo from '@/components/Logo';
import Menu from '@/icons/menu.svg';

import AuthButtons from './AuthButtons';
import { SidebarMobile } from './Menu';
import { useMenuItems } from './hooks';

function Header() {
	const { t } = useTranslation();

	const [sidebarOpen, setSidebarOpen] = useState(false);

	const menuItems = useMenuItems();

	return (
		<>
			<header className="fixed z-20 w-full bg-black">
				<div className="flex h-[52px] items-center justify-between px-5 lg:h-[72px] lg:px-6">
					<Logo />
					<div className="hidden lg:flex lg:items-center">
						<div className="absolute inset-x-0 mx-auto flex w-fit gap-3">
							{menuItems.map((item, index) => {
								return (
									<Button
										Component={Link}
										size="sm"
										className="font-normal hover:bg-white/10"
										type="button"
										key={`menu-${index}`}
										to={item.to}
									>
										<span className="hidden text-sm leading-[24px] text-white transition-colors sm:block">
											{t(item.text)}
										</span>
									</Button>
								);
							})}
						</div>
						<div className="flex gap-2">
							<AuthButtons />
						</div>
					</div>
					<Button
						variant="ghost"
						size="icon"
						className="inline-flex p-2 text-white hover:text-black lg:hidden"
						onClick={() => setSidebarOpen(true)}
						aria-label={t('labels.menu')}
					>
						<Menu />
					</Button>
				</div>
			</header>
			<div className="h-[52px] lg:h-[72px]" />

			<SidebarMobile open={sidebarOpen} onChange={setSidebarOpen} />
		</>
	);
}

export default Header;
